import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  FormHelperText,
  TextField,
} from '@mui/material';
import { MdClose } from '@teamworksdev/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InstructionEditData } from './types';

interface InstructionDrawerProps {
  instruction: string | null | undefined;
  setInstructionEditData: (data: InstructionEditData | null) => void;
  editInstruction: (instruction: string) => void;
  maxLength?: number;
}

export const InstructionDrawer = ({
  instruction: _instruction,
  setInstructionEditData,
  editInstruction,
  maxLength = 100,
}: InstructionDrawerProps) => {
  const { t } = useTranslation();
  const [instruction, setInstruction] = useState(_instruction || '');
  const isInvalid = instruction.length > maxLength;

  return (
    <Drawer
      open={true}
      onClose={() => setInstructionEditData(null)}
      anchor="right"
      sx={{
        '& .MuiPaper-root': {
          minWidth: '25%',
        },
      }}
    >
      <DialogTitle
        sx={{
          mt: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {t('instruction')}
        <button
          aria-label={t('close')}
          onClick={() => {
            setInstructionEditData(null);
          }}
        >
          <MdClose size={24} />
        </button>
      </DialogTitle>
      <DialogContent>
        <FormControl variant="outlined" fullWidth>
          <TextField
            multiline
            label={t('instruction')}
            inputProps={{
              style: {
                marginTop: 1,
                minHeight: 150,
              },
            }}
            value={instruction}
            onChange={(e) => setInstruction(e.target.value)}
          />
          <FormHelperText
            sx={{
              display: 'flex',
              justifyContent: 'right',
              mx: 0,
              color: isInvalid ? 'red' : 'inherit',
            }}
          >
            {instruction.length}/{maxLength}
          </FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setInstructionEditData(null)} variant="outlined">
          {t('cancel')}
        </Button>
        <Button
          disabled={isInvalid}
          onClick={() => {
            setInstructionEditData(null);
            editInstruction(instruction);
          }}
        >
          {t('save')}
        </Button>
      </DialogActions>
    </Drawer>
  );
};
